"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var public_api_1 = require("@l2p/public-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Timer_1 = __importDefault(require("./Timer"));
var dayToIndex = (_a = {},
    _a[public_api_1.DayToActivate.Sunday] = 0,
    _a[public_api_1.DayToActivate.Monday] = 1,
    _a[public_api_1.DayToActivate.Tuesday] = 2,
    _a[public_api_1.DayToActivate.Wednesday] = 3,
    _a[public_api_1.DayToActivate.Thursday] = 4,
    _a[public_api_1.DayToActivate.Friday] = 5,
    _a[public_api_1.DayToActivate.Saturday] = 6,
    _a);
var getEndOfDay = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
};
var LimitedOffer = function (_a) {
    var _b;
    var withBigPreview = _a.withBigPreview, btnText = _a.btnText;
    var bonusesForUser = (0, swr_hooks_1.usePromotions)().data;
    var bonusesNextDeposit = (0, swr_hooks_1.useBonusesByType)(public_api_1.BonusType.Deposit).data;
    // const { data: affBonusData } = useAffiliateBonuses()
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var bonusToShow = (0, react_1.useMemo)(function () {
        if (isAuth) {
            return bonusesNextDeposit === null || bonusesNextDeposit === void 0 ? void 0 : bonusesNextDeposit.find(function (bonus) { var _a; return (_a = bonus.slug) === null || _a === void 0 ? void 0 : _a.includes(swr_hooks_1.BonusTag.SPECIAL_OFFER); });
        }
        return bonusesForUser === null || bonusesForUser === void 0 ? void 0 : bonusesForUser.find(function (bonus) {
            return bonus.slug === swr_hooks_1.BonusTag.WELCOME_DEPOSIT_FIRST ||
                bonus.slug === swr_hooks_1.BonusTag.SPECIAL_OFFER;
        });
    }, [bonusesForUser, isAuth]);
    var timerEndDate = (0, react_1.useMemo)(function () {
        if (!isAuth || !(bonusToShow === null || bonusToShow === void 0 ? void 0 : bonusToShow.conditions))
            return undefined;
        var depositEndDate = bonusToShow.conditions.find(function (condition) { return condition.type === public_api_1.BonusConditionType.EndDate; });
        var depositMinDepositAmount = bonusToShow.conditions.find(function (condition) { return condition.type === public_api_1.BonusConditionType.MinDepositAmount; });
        var depositCountCondition = depositEndDate || depositMinDepositAmount;
        if (!depositCountCondition)
            return undefined;
        if (depositCountCondition.endDate)
            return depositCountCondition.endDate;
        var daysToActivate = depositCountCondition.daysToActivate || [];
        if (daysToActivate.length === 0)
            return undefined;
        var today = new Date();
        var todayIndex = today.getDay();
        var activeIndexes = new Set(daysToActivate
            .map(function (day) { return dayToIndex[day]; })
            .filter(function (index) { return index !== undefined; }));
        if (!activeIndexes.has(todayIndex))
            return undefined;
        var lastIndex = todayIndex;
        for (var step = 1; step <= 7; step++) {
            var next = (todayIndex + step) % 7;
            if (!activeIndexes.has(next))
                break;
            lastIndex = next;
        }
        var diff = (lastIndex - todayIndex + 7) % 7;
        var endDate = new Date(today);
        endDate.setDate(today.getDate() + diff);
        return getEndOfDay(endDate);
    }, [bonusToShow, isAuth]);
    if (!bonusToShow)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                react_1.default.createElement("span", null, t('limitedTimeOffer')),
                ' ',
                react_1.default.createElement(Timer_1.default, { dateEndTimer: timerEndDate })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusTitle }, translateLocale(bonusToShow === null || bonusToShow === void 0 ? void 0 : bonusToShow.title)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusDescription }, translateLocale((_b = bonusToShow === null || bonusToShow === void 0 ? void 0 : bonusToShow.descriptions) === null || _b === void 0 ? void 0 : _b.short)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", width: "100%", maxWidth: "336px", height: "56px", onClick: isAuth ? openDeposit : openSignUp }, btnText ? btnText : t('makeADeposit')))),
        withBigPreview ? (react_1.default.createElement("img", { className: styles_module_scss_1.default.image, src: "/img/limited-offer/bigPreview.png", alt: "welcome" })) : (react_1.default.createElement("img", { className: styles_module_scss_1.default.banner, src: "/img/limited-offer/banner.png", alt: "limited offer" }))));
};
exports.default = LimitedOffer;
